// extracted by mini-css-extract-plugin
export default {"shared":"\"../../../shared.module.css\"","md":"768px","fillIn":"FillIn_fillIn__hlVHV"};